import { api } from '~/services/api'

/**
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
export const apiGetListCheckInEmployee = (params) => {
  const uri = `/checkin/get-list-checkin`
  return api.get(uri, params)
}

